import axios from 'axios'

import config from '../../config.client.js'

const url = config.apiUrl

export default {
  getTranslationsForLanguage: (language, prefix) =>
    axios.get(url + `translations/${language}/${prefix}`),

  updateTranslationsForLanguage: (language, prefix, translations) =>
    axios.post(url + `translations/${language}/${prefix}`, { translations: translations }),

  getAccounts: () => axios.get(url + 'accounts'),

  getOrganisation: id => axios.get(url + 'organisations/' + id),

  getOrganisations: () => axios.get(url + 'organisations'),

  addOrganisation: (name, notes, wopiUnitPrice, creditsWopi, creditsWopi360) =>
    axios.post(url + 'organisations', {
      name,
      notes,
      unitPriceWopi: parseInt(wopiUnitPrice),
      creditsWopi: parseInt(creditsWopi),
      creditsWopi360: parseInt(creditsWopi360)
    }),

  updateOrganisation: (id, name, notes, unitPriceWopi, addCreditsWopi, addCreditsWopi360) =>
    axios.patch(url + 'organisations/' + id, {
      name,
      notes,
      unitPriceWopi: parseInt(unitPriceWopi),
      addCreditsWopi: parseInt(addCreditsWopi),
      addCreditsWopi360: parseInt(addCreditsWopi360)
    }),

  deleteOrganisation: id => axios.delete(url + 'organisations/' + id),

  addAccount: (email, givenName, familyName, organisationId, initialLanguage, roles) =>
    axios.post(url + 'accounts', {
      email: email.toLowerCase(),
      givenName: givenName,
      familyName: familyName,
      organisationId: parseInt(organisationId),
      language: initialLanguage,
      roles: roles
    }),

  getUsageLogSummary: (year, month) => axios.get(url + `log/usage/${year}/${month}`)
}



// WEBPACK FOOTER //
// ./src/services/super-admin.js